<template>
  <b-card title="Setup Surat Tugas">
    <b-form @submit.prevent="saveData">
      <b-row>
        <!-- Nama -->
        <b-col md="6">
          <b-form-group label="Nama Penandatangan" label-for="nama">
            <b-form-input
              id="nama"
              v-model="formData.nama"
              placeholder="Contoh: Prof. Dr. Nama Lengkap, M.Si."
            />
          </b-form-group>
        </b-col>

        <!-- Jabatan -->
        <b-col md="6">
          <b-form-group label="Jabatan" label-for="jabatan">
            <b-form-input
              id="jabatan"
              v-model="formData.jabatan"
              placeholder="Contoh: Wakil Dekan Bidang Pendidikan, Penelitian dan Kemahasiswaan"
            />
          </b-form-group>
        </b-col>

        <!-- NUP -->
        <b-col md="3">
          <b-form-group label="Label ID" label-for="nip_nup_label">
            <b-form-select
              id="nip_nup_label"
              v-model="formData.nip_nup_label"
              :options="['NUP', 'NIP']"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group :label="formData.nip_nup_label" label-for="nup">
            <b-form-input
              id="nup"
              v-model="formData.nup"
              :placeholder="'Masukkan ' + formData.nip_nup_label"
            />
          </b-form-group>
        </b-col>

        <!-- Signature Image -->
        <b-col md="6">
          <b-form-group label="Tanda Tangan (Image)" label-for="signature">
            <div class="d-flex align-items-center mt-1">
              <b-img
                v-if="previewImage || formData.signature_image_url"
                :src="previewImage || formData.signature_image_url"
                height="80"
                class="mr-2 border rounded"
              />
              <div v-else class="mr-2 border rounded d-flex align-items-center justify-content-center" style="width: 100px; height: 80px; background-color: #f8f8f8;">
                <small class="text-muted">No Image</small>
              </div>
              <b-form-file
                id="signature"
                v-model="signatureFile"
                accept="image/*"
                placeholder="Pilih file atau drag ke sini..."
                drop-placeholder="Drop file di sini..."
                @change="onFileChange"
              />
            </div>
            <small class="text-muted mt-25 d-block">Gunakan format PNG transparan untuk hasil terbaik.</small>
          </b-form-group>
        </b-col>

        <!-- Paraf Image -->
        <b-col md="6">
          <b-form-group label="Paraf (Image)" label-for="paraf">
            <div class="d-flex align-items-center mt-1">
              <b-img
                v-if="previewParaf || formData.paraf_image_url"
                :src="previewParaf || formData.paraf_image_url"
                height="80"
                class="mr-2 border rounded"
              />
              <div v-else class="mr-2 border rounded d-flex align-items-center justify-content-center" style="width: 100px; height: 80px; background-color: #f8f8f8;">
                <small class="text-muted">No Image</small>
              </div>
              <b-form-file
                id="paraf"
                v-model="parafFile"
                accept="image/*"
                placeholder="Pilih file paraf..."
                @change="onParafChange"
              />
            </div>
            <small class="text-muted mt-25 d-block">Digunakan untuk paraf di bagian bawah surat.</small>
          </b-form-group>
        </b-col>



        <!-- Submit Button -->
        <b-col cols="12" class="mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
            :disabled="loading"
          >
            <b-spinner v-if="loading" small class="mr-25" />
            Simpan Perubahan
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard, BForm, BRow, BCol, BFormGroup, BFormInput, BFormFile, BButton, BImg, BSpinner, BFormSelect,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@/libs/axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard, BForm, BRow, BCol, BFormGroup, BFormInput, BFormFile, BButton, BImg, BSpinner, BFormSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      formData: {
        nama: '',
        jabatan: '',
        nup: '',
        nip_nup_label: 'NUP',
        signature_image_url: null,
        paraf_image_url: null,
      },
      signatureFile: null,
      parafFile: null,
      previewImage: null,
      previewParaf: null,
      loading: false,
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      axios.get('admin/setup-surat-tugas')
        .then(res => {
          if (res.data.success && res.data.data) {
            const data = res.data.data
            this.formData.nama = data.nama || ''
            this.formData.jabatan = data.jabatan || ''
            this.formData.nup = data.nup || ''
            this.formData.nip_nup_label = data.nip_nup_label || 'NUP'
            if (data.signature_image_url) {
              this.formData.signature_image_url = data.signature_image_url
            }
            if (data.paraf_image_url) {
              this.formData.paraf_image_url = data.paraf_image_url
            }
          }
        })
        .catch(err => {
          console.error(err)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Gagal mengambil data',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    onFileChange(e) {
      const file = e.target.files[0]
      if (file) {
        this.previewImage = URL.createObjectURL(file)
      }
    },
    onParafChange(e) {
      const file = e.target.files[0]
      if (file) {
        this.previewParaf = URL.createObjectURL(file)
      }
    },
    saveData() {
      this.loading = true
      const data = new FormData()
      data.append('nama', this.formData.nama)
      data.append('jabatan', this.formData.jabatan || '')
      data.append('nup', this.formData.nup)
      data.append('nip_nup_label', this.formData.nip_nup_label)
      if (this.signatureFile) {
        data.append('signature_image', this.signatureFile)
      }
      if (this.parafFile) {
        data.append('paraf_image', this.parafFile)
      }

      axios.post('admin/setup-surat-tugas', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(res => {
          this.loading = false
          if (res.data.success) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Berhasil disimpan',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            const data = res.data.data
            this.formData.nama = data.nama || ''
            this.formData.jabatan = data.jabatan || ''
            this.formData.nup = data.nup || ''
            this.formData.nip_nup_label = data.nip_nup_label || 'NUP'
            if (data.signature_image_url) {
              this.formData.signature_image_url = data.signature_image_url
            }
            if (data.paraf_image_url) {
              this.formData.paraf_image_url = data.paraf_image_url
            }
            this.previewImage = null
            this.previewParaf = null
            this.signatureFile = null
            this.parafFile = null
          }
        })
        .catch(err => {
          this.loading = false
          console.error(err)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Gagal menyimpan data',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>
